// ReportStyle.ts

export const reportMerges: any[] = [];
export const reportColWidths = (index: number): number => 100;
export function getReportCellClassNames(row: number, col: number): string[] { return []; } 